module.exports = __webpack_public_path__ + "static/continental-6442ca68b65da936883a3aa377fd0f0f.png";